import Container from '../../components/Container/Container'
import Breadcrumbs from '../../components/ui/Breadcrumbs/Breadcrumbs'
import styles from './NotFoundPage.module.css'
import MainButton from '../../components/ui/MainButton/MainButton'
import { useErrorPageMeta } from '../../hooks/usePageMeta'
import { NOT_FOUND_META } from '../../utils/pageMeta'

export default function NotFoundPage() {
  useErrorPageMeta(NOT_FOUND_META.title, NOT_FOUND_META.description)
  return (
    <Container>
      <Breadcrumbs />
      <div className={styles.notFoundPage}>
        <img src="/images/not-found.svg" alt="not-found" />
        <div className={styles.content}>
          <h1 className={styles.title}>Йой. Сіт знову щось наклацав</h1>
          <p className={styles.description}>
            Онови сторінку або повернися назад — і давай почнемо все спочатку
          </p>
          <div className={styles.actions}>
            <MainButton text="На головну" href="/" />
          </div>
        </div>
      </div>
    </Container>
  )
}
